import GridLayout from "./GridLayout/GridLayout";
import TableLayout from "./TableLayout/TableLayout";
import { PartListBox } from "./PartList.style";

import { useState } from "react";
import DrawerPartDetails from "../PartDetails/DrawerPart/DrawerPartDetails";
import { defaultLayoutSearch } from "../../configuration/defaultSettings";

export enum ColumnWidth {
    IconWidth,
    TextWidth,
    ShortTextWidth,
}

export enum ColumnAlign {
    Left = "left",
    Center = "center",
    Right = "right",
}

export type TColumns = {
    name: string;
    viewHeader: boolean;
    width?: ColumnWidth;
    customComponent?: React.ElementType;
    align?: ColumnAlign;
    additionalProps?: any;
    headerText?: string | undefined;
    useHeaderTooltip?: boolean | undefined;
};

type TPartList = {
    items: any;
    layout?: string;
    loading: boolean;
    columns: TColumns[];
    calloutNotified?: string;
    notifyCallout?: (position?: string) => void;
    notifyPart?: (part?: string) => void;
    partNotified?: string;
    showPart?: string;
    emptyPage?: React.ElementType;
    onRowClick?: (
        code: string,
        replacementCode: string,
        manufacturer: string,
        position: string,
        parentNaturalKey: string
    ) => void;
    onOfferOrderRowClick?: (
        offerCode: string,
        orderCode: string,
        orderType: string,
        customerOfferCode: string,
        customerOrderCode: string,
      ) => void;
};

const PartList = (props: TPartList) => {
    const [_, setShowSelectedMachineDesc] = useState(true);

    const handleScroll = (event: React.UIEvent<HTMLElement>) => {
        setShowSelectedMachineDesc(event.currentTarget.scrollTop < 200);
    };

    const defaultProp: TPartList = {
        items: props.items,
        layout: props.layout ?? defaultLayoutSearch,
        loading: props.loading ?? false,
        columns: props.columns,
    };

    return (
        <PartListBox>
            {defaultProp.layout === "T" ? (
                <TableLayout
                    items={defaultProp.items}
                    loading={defaultProp.loading}
                    handleScroll={handleScroll}
                    columns={defaultProp.columns}
                    calloutNotified={props.calloutNotified}
                    notifyCallout={props.notifyCallout}
                    notifyPart={props.notifyPart}
                    partNotified={props.partNotified}
                    showPart={props.showPart}
                    emptyPage={props.emptyPage}
                    onRowClick={props.onRowClick}
                    onOfferOrderRowClick={props.onOfferOrderRowClick}
                />
            ) : (
                <GridLayout
                    items={defaultProp.items}
                    loading={defaultProp.loading}
                    handleScroll={handleScroll}
                />
            )}
            <DrawerPartDetails />
        </PartListBox>
    );
};

export default PartList;
